import { render, staticRenderFns } from "./arrange-bus.vue?vue&type=template&id=58670232&"
import script from "./arrange-bus.vue?vue&type=script&lang=js&"
export * from "./arrange-bus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports